const topics = [
  {
    tag: '热门推荐',
    title: '暑期档必看大片合集',
    desc: '整理今夏最值得看的院线大片与经典回顾，从动作到悬疑一网打尽',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20summer%20movie%20marathon%20scene%20with%20popcorn%20and%20drinks%20on%20a%20coffee%20table%2C%20large%20TV%20screen%20showing%20action%20movie%20scene%2C%20bright%20airy%20living%20room%20with%20sunlight%2C%20cheerful%20atmosphere%2C%20warm%20gold%20and%20cream%20tones&width=640&height=400&seq=carousel-summer-01&orientation=landscape',
  },
  {
    tag: '高分剧集',
    title: '豆瓣9分以上神剧盘点',
    desc: '精选中外高分电视剧，每一部都值得反复观看，口碑炸裂不容错过',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20flat%20lay%20of%20a%20minimalist%20desk%20with%20a%20laptop%20showing%20a%20video%20streaming%20interface%20displaying%20various%20high%20rated%20TV%20series%20posters%2C%20surrounded%20by%20coffee%20cup%20and%20notebook%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20workspace&width=640&height=400&seq=carousel-douban-02&orientation=landscape',
  },
  {
    tag: '独家专题',
    title: '国产悬疑剧崛起之路',
    desc: '从隐秘的角落到漫长的季节，国产悬疑剧精品频出，深度解析不可不看',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20atmosphere%20with%20dramatic%20lighting%20casting%20long%20shadows%2C%20a%20single%20spotlight%20illuminating%20a%20vintage%20film%20reel%20on%20a%20wooden%20surface%2C%20mysterious%20and%20suspenseful%20mood%2C%20warm%20amber%20highlights%2C%20film%20noir%20aesthetic&width=640&height=400&seq=carousel-mystery-03&orientation=landscape',
  },
  {
    tag: '动漫天地',
    title: '日漫新番追更指南',
    desc: '最新日漫番剧资源同步更新，热血、治愈、奇幻各类题材一应俱全',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20collection%20of%20colorful%20anime%20style%20artwork%20displayed%20on%20a%20digital%20screen%2C%20bright%20energetic%20colors%2C%20various%20anime%20character%20designs%2C%20modern%20streaming%20interface%2C%20playful%20and%20dynamic%20composition%2C%20warm%20vibrant%20aesthetic&width=640&height=400&seq=carousel-anime-04&orientation=landscape',
  },
  {
    tag: '综艺娱乐',
    title: '热门综艺一网打尽',
    desc: '各大平台王牌综艺资源聚合，从脱口秀到真人秀，欢笑不断精彩不停',
    image: 'https://readdy.ai/api/search-image?query=A%20lively%20TV%20studio%20set%20with%20colorful%20stage%20lighting%2C%20entertainment%20variety%20show%20atmosphere%2C%20bright%20warm%20spotlights%2C%20cheerful%20vibe%2C%20professional%20broadcast%20studio%20environment%2C%20energetic%20and%20fun%20mood&width=640&height=400&seq=carousel-variety-05&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '那些年我们追过的港片',
    desc: '重温港片黄金年代，从周星驰到王家卫，经典永不褪色，情怀满分',
    image: 'https://readdy.ai/api/search-image?query=A%20retro%20vintage%20Hong%20Kong%20cinema%20style%20scene%20with%20old%20film%20posters%20on%20a%20weathered%20brick%20wall%2C%20warm%20neon%20sign%20glow%2C%20nostalgic%201990s%20atmosphere%2C%20classic%20movie%20theater%20exterior%20vibe%2C%20warm%20amber%20and%20red%20tones&width=640&height=400&seq=carousel-hkfilm-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">精选热门影视专题，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topics.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-accent-200 transition-all"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={`91影视看片app - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500/90 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}